/**
 * Модель для поиска сотрудников на карте
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import { IUserPosition } from './types';

import PositionsService from '../services/PositionsService';

interface IState {
  users: IUserPosition[];
}

const initialState: IState = {
  users: []
};

export const infrastructureSearch = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setUsers(state: IState, payload: IUserPosition[]): IState {
      return {
        ...state,
        users: payload
      };
    }
  },
  effects: () => ({
    async getUsers(fts: string) {
      const { data } = await PositionsService.getUsers({ fts });

      this.setUsers(data);
    }
  })
});
